'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _constants = require('../../constants');



var _googleService = require('../../helpers/googleService');var _googleService2 = _interopRequireDefault(_googleService);

var _formatDate = require('../../utils/formatDate');var _formatDate2 = _interopRequireDefault(_formatDate);
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _parkingConverter = require('../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);

var _FullScreenPropertyCell = require('./FullScreenPropertyCell.scss');var styles = _interopRequireWildcard(_FullScreenPropertyCell);
var _FullScreenPropertyCellGallery = require('./FullScreenPropertyCellGallery/FullScreenPropertyCellGallery');var _FullScreenPropertyCellGallery2 = _interopRequireDefault(_FullScreenPropertyCellGallery);
var _FullScreenPropertyCellPropertySummary = require('./FullScreenPropertyCellPropertySummary/FullScreenPropertyCellPropertySummary');var _FullScreenPropertyCellPropertySummary2 = _interopRequireDefault(_FullScreenPropertyCellPropertySummary);
var _FullScreenPropertyCellAdditionalInfo = require('./FullScreenPropertyCellAdditionalInfo/FullScreenPropertyCellAdditionalInfo');var _FullScreenPropertyCellAdditionalInfo2 = _interopRequireDefault(_FullScreenPropertyCellAdditionalInfo);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Constants
// Components
// Helpers
// import { formatPropertyTitle } from '../../utils/formatSEOData';
// Styles
// import FullScreenPropertyCellContacts from './FullScreenPropertyCellContacts/FullScreenPropertyCellContacts';
var FullScreenPropertyCell = function (_Component) {_inherits(FullScreenPropertyCell, _Component);function FullScreenPropertyCell() {var _temp, _this, _ret;_classCallCheck(this, FullScreenPropertyCell);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getFloorField = function () {var _this$props = _this.props,property = _this$props.property,translate = _this$props.translate;var floor = (0, _get2.default)(property, 'additional_info.floor.on_the');
      var floorOut = (0, _get2.default)(property, 'additional_info.floor.out_of');
      var isGroundFloor = (0, _get2.default)(property, 'additional_info.floor.on_the') === 0;
      var floorOn = isGroundFloor ? translate('propertyDetails', 'details', 'groundFloor') : floor;
      var isCottage = function isCottage() {return property.additional_info.property_type === 'cottage';};
      var floorField = isCottage() ?
      { value: '' + floorOn, title: 'floors' } :
      {
        value: floorOn + ' ' + translate('propertyDetails', 'details', 'outOf') + ' ' + floorOut,
        title: 'floor' };

      return floorField;
    }, _this.

    toggleFavorites = function (evt) {
      evt.stopPropagation();
      _this.props.toggleFavorite(_this.props.property.id);
    }, _this.

    openDetailsPopup = function () {var _this$props2 =
      _this.props,property = _this$props2.property,locale = _this$props2.locale;
      var englishAddressRequired = _constants.localesWithEnglishAddress.includes(locale);
      var address = englishAddressRequired ?
      property.address.en :
      property.address[_this.props.locale] || property.address[_constants.language.default];
      var floor = (0, _get2.default)(property, 'additional_info.floor.on_the');
      var propertyType = _this.props.translate('propertyTypes', property.property_type);
      _this.props.openDetailsPopup({
        propertyId: property.id,
        address: address,
        price: property.price,
        additionalInfo: {
          area: property.area,
          floor: floor === 0 ? _this.props.translate('propertyDetails', 'details', 'groundFloorShortcut').toString() : floor,
          parkingSpots: (0, _parkingConverter2.default)(property.additional_info.parking),
          rooms: property.additional_info.rooms },

        propertyType: propertyType });

      (0, _analyticsManager.trackModalOpen)('property/' + property.id);
    }, _this.

    fetchPropertyImages = function () {
      var propertyImages = [];var _this$props$property =
      _this.props.property,thumbnail = _this$props$property.thumbnail,images = _this$props$property.images,hasPhotos = _this$props$property.has_photos;var _ref =
      (0, _get2.default)(_this.props, 'property.address.location') || {},lat = _ref.lat,lng = _ref.lon;
      if (hasPhotos) {
        propertyImages = images.map(function (item) {return item.thumbnail;});
      } else {
        var image = thumbnail || null;
        propertyImages.push(image);
      }

      return propertyImages;
    }, _this.

    renderFavoriteIcon = function () {return (
        _react2.default.createElement('i', {
            onClick: _this.toggleFavorites,
            className: (0, _classnames2.default)(styles.favoriteIcon, 'favoriteToggler', {
              'icon-favorite-active-with-border': _this.props.isFavorite,
              'icon-favorite-disabled': !_this.props.isFavorite }) },


          _react2.default.createElement('i', { className: 'path1 favoriteToggler' }),
          _react2.default.createElement('i', { className: 'path2 favoriteToggler' })));}, _this.



    renderDate = function () {var _this$props$property2 =
      _this.props.property,createdAt = _this$props$property2.created_at,updatedAt = _this$props$property2.updated_at;
      if (!createdAt && !updatedAt) {
        return _react2.default.createElement('div', null);
      }
      var publishDate = (0, _formatDate2.default)(createdAt, _this.props.translate);
      var updateDate = createdAt !== updatedAt && (0, _formatDate2.default)(updatedAt, _this.props.translate);

      var rowRender = function rowRender(name, date, brackets) {return (
          _react2.default.createElement('span', null,
            brackets ? '(' : null,
            _react2.default.createElement('span', { className: styles.label }, _this.props.translate('propertyDetails', 'details', name)), ':\xA0',
            date,
            brackets ? ')' : null));};



      return (
        _react2.default.createElement('div', { className: styles.date },
          rowRender('publishDate', publishDate), '\xA0\xA0',

          updateDate && rowRender('updateDate', updateDate, true)));


    }, _this.

    renderMoreDetailsButton = function () {return (
        _react2.default.createElement('button', {
            className: styles.moreDetailsButton,
            onClick: _this.openDetailsPopup },

          _this.props.translate('propertyDetails', 'moreDetails')));}, _this.



    renderAddPrivatCommentButton = function () {return (
        _react2.default.createElement('button', { className: styles.addPrivatComment },
          _this.props.translate('propertyDetails', 'notesPlaceholder')));}, _temp), _possibleConstructorReturn(_this, _ret);}FullScreenPropertyCell.prototype.




  render = function render() {var _ref2;var _props =
    this.props,property = _props.property,translate = _props.translate,locale = _props.locale,isRtl = _props.isRtl,addPropertyNote = _props.addPropertyNote,propertyNote = _props.propertyNote;
    // const sharingUrl = makeSharingUrl(`/home_details/${property.id}`, locale);
    // const sharingTitle = formatPropertyTitle(
    //   property,
    //   property.property_type,
    //   translate('propertyDetails'),
    //   locale
    // );
    var propertyType = translate('propertyTypes', property.property_type);
    // const contactsData = { propertyId: property.id, isActive: property.is_active, sharingUrl, sharingTitle, thumbnail };
    var floorField = this.getFloorField();
    var favoriteButton = this.renderFavoriteIcon();var _property$additional_ =








    property.additional_info,rooms = _property$additional_.rooms,bathrooms = _property$additional_.bathrooms,toilets = _property$additional_.toilets,elevators = _property$additional_.elevators,balconies = _property$additional_.balconies,area = _property$additional_.area,parking = _property$additional_.parking;

    return (
      _react2.default.createElement('div', { className: styles.fullScreenPropertyCell },
        _react2.default.createElement('div', { className: styles.fullScreenPropertyImage },
          favoriteButton,
          _react2.default.createElement(_FullScreenPropertyCellGallery2.default, {
            isRtl: isRtl,
            images: this.fetchPropertyImages(),
            translate: translate })),


        _react2.default.createElement('div', { className: styles.fullScreenPropertyCellInfo },
          _react2.default.createElement('div', { className: styles.topLine },
            _react2.default.createElement('div', { className: styles.infoBlock },
              _react2.default.createElement(_FullScreenPropertyCellPropertySummary2.default, {
                price: property.price,
                address: property.address,
                propertyType: propertyType,
                locale: locale,
                isRtl: isRtl,
                id: property.id,
                addPropertyNote: addPropertyNote,
                propertyNote: propertyNote })),


            _react2.default.createElement('div', { className: styles.infoBlock },
              _react2.default.createElement(_FullScreenPropertyCellAdditionalInfo2.default, {
                properties: (_ref2 = {
                  rooms: rooms }, _ref2[
                floorField.title] = floorField.value, _ref2.
                area = area.base, _ref2.
                parkingSpots = (0, _parkingConverter2.default)(parking), _ref2),

                translate: translate })),


            _react2.default.createElement('div', { className: styles.infoBlock },
              _react2.default.createElement(_FullScreenPropertyCellAdditionalInfo2.default, {
                properties: {
                  bath: bathrooms,
                  balcony: balconies,
                  toilets: toilets,
                  elevator: elevators },

                translate: translate }))),

















          _react2.default.createElement('div', { className: styles.bottomLine },
            _react2.default.createElement('div', { className: styles.rightColumn },
              this.renderDate()),


            this.renderMoreDetailsButton()))));




  };return FullScreenPropertyCell;}(_react.Component);exports.default = FullScreenPropertyCell;


FullScreenPropertyCell.propTypes = {
  property: _propTypes2.default.object,
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  isFavorite: _propTypes2.default.bool,
  propertyNote: _propTypes2.default.string,
  addPropertyNote: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FullScreenPropertyCell/FullScreenPropertyCell.js
// module id = 2667
// module chunks = 0